import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl sm:p-10">
          <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
            <div>
              <h2
                className="text-2xl font-semibold tracking-tight sm:text-3xl"
                style={{ fontFamily: "var(--font-display)" }}
              >
                Build a Trust-First Digital Enterprise
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-7 text-[var(--text-secondary)] sm:text-base">
                Identity is the foundation of digital trust. Let us help you build it right.
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center rounded-xl bg-[var(--accent-trust)] px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-blue-500/20 transition-transform hover:translate-y-[-1px] focus:outline-none focus:ring-2 focus:ring-[var(--accent-cyan)]/60"
                >
                  Start Identity Maturity Assessment
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center rounded-xl border border-white/10 bg-white/[0.02] px-5 py-3 text-sm font-semibold text-[var(--text-primary)] transition-colors hover:bg-white/[0.05] focus:outline-none focus:ring-2 focus:ring-[var(--accent-trust)]/60"
                >
                  Schedule Executive Workshop
                </Link>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-[var(--gradient-card)] p-6">
              <div className="text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
                Contact
              </div>
              <div className="mt-3 grid gap-2 text-sm">
                <div className="text-[var(--text-secondary)]">
                  Email: <span className="text-[var(--text-primary)]">info@ivalue.co.in</span>
                </div>
                <div className="text-[var(--text-secondary)]">Phone: <span className="text-[var(--text-primary)]">+91 95359 99473</span></div>
                <div className="text-[var(--text-secondary)]">Locations: <span className="text-[var(--text-primary)]">iValue Group (India-HQ) No. 903/1/1, 19th Main Road, 4th Sector, H.S.R. Layout, Bangalore – 560102</span></div>
              </div>
              <div className="mt-6 flex gap-3">
                <a
                  className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 text-sm text-[var(--text-secondary)] transition-colors hover:bg-white/[0.05] hover:text-[var(--text-primary)]"
                  href="https://www.linkedin.com/company/ivalue-infosolutions-pvt-ltd"
                >
                  LinkedIn
                </a>
                <a
                  className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 text-sm text-[var(--text-secondary)] transition-colors hover:bg-white/[0.05] hover:text-[var(--text-primary)]"
                  href="https://twitter.com/iValueInfoSoln"
                >
                  Twitter
                </a>
                <a
                  className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 text-sm text-[var(--text-secondary)] transition-colors hover:bg-white/[0.05] hover:text-[var(--text-primary)]"
                  href="https://github.com/Ivalue-Dev-Team"
                >
                  Github
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-[var(--text-secondary)] sm:flex-row sm:items-center sm:justify-between">
            <div>© {new Date().getFullYear()} Identity, Data & Key Security CoE</div>
            <div className="font-mono">Identity is the control plane.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
